import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { ApplicationPaths } from "../../constants/application-paths";
import { Id06ConsentData } from "../../id06-consent/models/id06-consent-data.model";
import { Id06ConsentActions } from "../../id06-consent/state/id06-consent.actions";
import { Id06ConsentState } from "../../id06-consent/state/id06-consent.state";
import { Certificate } from "../models/certificate.model";
import { CertificateStateActions } from "../state/certificate.actions";
import { CertificateState } from "../state/certificate.state";
import { SSGConsentActions } from "../../ssg-consent/state/ssg-consent.actions";
import { SSGConsentState } from "../../ssg-consent/state/ssg-consent.state";
import { SSGConsentData } from "../../ssg-consent/models/ssg-consent-data.model";

@Component({
    selector: "certificate",
    templateUrl: "./certificate.component.html",
    styleUrls: ["./certificate.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CertificateComponent implements OnInit {
    @Select(CertificateState.certificate)
    public certificate$: Observable<Certificate>;

    @Select(Id06ConsentState.data)
    public consentData$: Observable<Id06ConsentData>;

    @Select(SSGConsentState.data)
    public ssgConsentData$: Observable<SSGConsentData>;

    public ssgConsentRoute = ApplicationPaths.Certificate.SsgConsent;
    public id06ConsentRoute = ApplicationPaths.Certificate.Id06Consent;
    public cardOrderRoute = ApplicationPaths.Certificate.CardOrder;
    public replacementCardRequestRoute = ApplicationPaths.Certificate.ReplacementCardRequest;

    constructor(private store: Store) {}

    public ngOnInit(): void {
        this.store.dispatch(new CertificateStateActions.GetCertificate());
        this.store.dispatch(new Id06ConsentActions.GetData());
        this.store.dispatch(new SSGConsentActions.GetData());
    }
}
